import { useState } from "react";
import { FlatList, StyleSheet } from "react-native-web";
import { LinearGradient } from "tamagui/linear-gradient";
import { Avatar, Button, Image, Text, View, styled, Paragraph, Separator, useWindowDimensions, XStack } from "tamagui";
import { useLink, color, getImageColorStyle, MiscUtils } from "@my/util";
import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
const items = Array.from({
  length: 100
}).map((_, index) => index);
const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    //marginBottom: 100,
    cursor: "pointer",
    borderRadius: 15,
    border: "1px solid rgba(220,220,220, .25)",
    backgroundColor: "white"
  },
  iconContainer: {
    width: 133,
    height: 133,
    borderRadius: 100,
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: "rgba(220,220,220, .15)"
    //color.tzaGreen,
  },
  label: {
    fontSize: 14,
    fontWeight: "400",
    color: color.grey,
    textAlign: "center",
    lineHeight: 16.9
  }
});
const padding = 20;
const baseWidth = 300;
const List = styled(FlatList, {});
const renderItem = ({
  item,
  index
}) => {
  return /* @__PURE__ */jsx(Item, {
    data: {
      index
    }
  }, item);
};
function FlatGrid() {
  const {
    width: deviceWidth
  } = useWindowDimensions();
  const numberOfColumns = Math.round((deviceWidth - padding) / baseWidth);
  return /* @__PURE__ */createElement(List, {
    ...(numberOfColumns > 1 && {
      columnWrapperStyle: {
        gap: 22
      }
    }),
    "$group-window-gtXs": {
      p: padding,
      height: 500
    },
    contentContainerStyle: {
      gap: 16
    },
    showsVerticalScrollIndicator: false,
    numColumns: numberOfColumns,
    key: numberOfColumns,
    data: items,
    renderItem
  });
}
FlatGrid.fileName = "FlatGrid";
const whiteFilter = getImageColorStyle(color.white);
const tzaGreenFilter = getImageColorStyle(color.tzaGreen);
const tzaDarkNavyFilter = getImageColorStyle(color.darkNavy);
function Item({
  data,
  iconContainer,
  container,
  gap
}) {
  const {
    key,
    img,
    imgHeight,
    imgWidth,
    link
  } = data;
  const screenWidth = useWindowDimensions().width;
  const numberOfColumns = (() => {
    const num = Math.round((screenWidth - 20) / 135);
    const num1 = num < 6 ? Math.min(4, num) : Math.min(6, num);
    return num1;
  })();
  const totalGapSpace = gap * (numberOfColumns - 1);
  const availableWidth = screenWidth - totalGapSpace;
  const singleColumnWidthPx = availableWidth / numberOfColumns;
  const oldWidthPct = 100 / numberOfColumns + "%";
  const widthPercentage = `${singleColumnWidthPx / screenWidth * 100}%`;
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);
  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);
  const handlePressIn = () => setIsPressed(true);
  const handlePressOut = () => setIsPressed(false);
  const gradientColors = [];
  const tintColors = isHovered || isPressed ? color.white : color.tzaGreen;
  const tintFilter = /*isHovered || isPressed ? whiteFilter :*/
  tzaGreenFilter;
  const buttonBg = isHovered || isPressed ? "rgba(200, 200, 200, 0.15)" : color.white;
  const labelStyle = {
    ...styles.label,
    fontSize: key === "Recommendations" ? 12 : numberOfColumns === 3 ? 13 : 14
  };
  return /* @__PURE__ */jsx(XStack, {
    style: {
      alignItems: "center",
      minWidth: 120,
      width: oldWidthPct,
      paddingLeft: 5,
      paddingRight: 5,
      paddingBottom: 30
    },
    children: /* @__PURE__ */jsxs(Button, {
      ...useLink(link),
      unstyled: true,
      ...MiscUtils.ui.shadowGenerator(0.02, 5),
      style: [styles.container,, {
        width: "100%",
        height: "100%"
      }, container],
      hoverStyle: {
        backgroundColor: "rgba(200, 200, 200, 0.10)"
      },
      pressStyle: {
        backgroundColor: "rgba(200, 200, 200, 0.10)"
      },
      children: [/* @__PURE__ */jsx(LinearGradient, {
        colors: gradientColors,
        start: [1, 0],
        end: [0, 1],
        ...MiscUtils.ui.shadowGenerator(0.03, 5),
        style: [styles.iconContainer, iconContainer],
        children: /* @__PURE__ */jsx(Image, {
          resizeMode: "contain",
          src: img,
          style: {
            width: imgWidth || iconContainer.width,
            height: imgHeight || iconContainer.height,
            ...tzaDarkNavyFilter
          }
        })
      }), /* @__PURE__ */jsx(Text, {
        style: labelStyle,
        numberOfLines: 2,
        ...(key === "Recommendations" ? {
          transform: [{
            scaleY: 1.1
          }]
        } : {}),
        children: key
      })]
    })
  });
}
function FlatListGridView({
  data,
  iconContainer,
  container,
  columns,
  parentWidth
}) {
  const gap = 0;
  return /* @__PURE__ */jsx(View, {
    width: "100%",
    children: /* @__PURE__ */jsx(XStack, {
      style: {
        width: "100%",
        flexWrap: "wrap",
        justifyContent: "center",
        gap
      },
      children: data.map((item, index) => /* @__PURE__ */jsx(Item, {
        data: item,
        iconContainer,
        container,
        gap
      }, index))
    })
  });
}
FlatListGridView.fileName = "FlatListGridView";
export { FlatGrid, FlatListGridView };
//# sourceMappingURL=FlatListGridView.mjs.map
